import { SERVER_URL } from "../../../constants";
import { fetchGetAuth } from "../../../util/FetchUtil";

const controller = "cupom-cantina/";

export const findCupomCantinaByCurrentUser = (page) => {
  const url =
    SERVER_URL + controller + "query-page?type=current-user&page=" + page;
  return fetchGetAuth(url);
};

export const findCupomCantinaByAlunoCodigo = (codAluno, page) => {
  const url =
    SERVER_URL +
    controller +
    "query-page?cod-aluno=" +
    codAluno +
    "&page=" +
    page;
  return fetchGetAuth(url);
};
